import React from 'react'

function Tab3() {
    return (
        <div>
            <div className='grid md:grid-cols-2 mt-20 mx-5'>
                <div>

                    <div className=' mb-20'>
                        <h3 className="text-sm font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">2020 - Present</h3>
                        <h1 className='text-4xl font-bold'>Marketplace Experience</h1>
                    </div>

                    <ol className="border-l-2 border-black">
                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">

                                </div>
                                <div className="block p-6 rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">WordPress Developer</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Fiverr (2020- Present)</p>

                                    <p className="text-[#878E99] text-lg mb-6">I was joined Fiverr since 2020. I have completed more than 30+ projects in Fiverr and I have 20+ happy Clients.</p>

                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">

                                </div>
                                <div className="block p-6 rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">Web Developer</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Upwork (2020- Present)</p>

                                    <p className="text-[#878E99] text-lg mb-6">I was joined Upwork since 2020. I have completed more than 10+ projects in Upwork.</p>

                                </div>
                            </div>
                        </li>


                    </ol>
                </div>

                <div>
                    <div className=' mb-20'>
                        <h3 className="text-sm font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">2021 - Present</h3>
                        <h1 className='text-4xl font-bold'>Job Experience</h1>
                    </div>

                    <ol className="border-l-2 border-black">
                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">

                                </div>
                                <div className="block p-6 rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">Web Developer</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-3">(Uttar Pradesh - India)</p>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Carikture Software Company (2023- Present)</p>

                                    <p className="text-[#878E99] text-lg mb-6">I have joined CariKture Software Testing Development Company India as a Web Developer. I make any
                                        type of website using html, css, javascript, jQuery, bootstrap, tailwindcss, reactjs for this company</p>

                                </div>
                            </div>
                        </li>


                        <li>
                            <div className="md:flex flex-start">
                                <div className="bg-black w-6 h-6 flex items-center justify-center rounded-full -ml-3">

                                </div>
                                <div className="block p-6 rounded-lg shadow-lg bg-[#212428] max-w-md ml-6 mb-10">
                                    <div className="flex justify-between mb-2">
                                        <a href="#!" className="font-font-semibold  hover:text-white focus:text-white duration-300 transition ease-in-out text-2xl">Virtual Assistant</a>
                                    </div>
                                    <p href="#!" className="font-medium text-[#878E99] hover:text-white focus:text-white duration-300 transition ease-in-out text-lg mb-10">Au Naturale Cosmetics (2021- 2022)</p>

                                    <p className="text-[#878E99] text-lg mb-6">I was joined Au Naturale Cosmetics as a Virtual Assistant. I was maintained their all marketing campaigns and manage workers.</p>

                                </div>
                            </div>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    )
}

export default Tab3
